import React from 'react'

export default function footer() {
  return (
   <>
  <footer id="footer">
    <div className="layer-stretch">
      <div className="row layer-wrapper">
        <div className="col-md-4 footer-block">
          <div className="footer-ttl">
            <p>Basic Info</p>
          </div>
          <div className="footer-container footer-a">
            <div className="tbl">
              <div className="tbl-row">
                <div className="tbl-cell">
                  <i className="far fa-map" />
                </div>
                <div className="tbl-cell">
                  <p className="paragraph-medium paragraph-white">
                    Address Line 11, Address Line 2, City, Country, 0123456
                  </p>
                </div>
              </div>
              <div className="tbl-row">
                <div className="tbl-cell">
                  <i className="fas fa-mobile-alt" />
                </div>
                <div className="tbl-cell">
                  <p className="paragraph-medium paragraph-white">1234567890</p>
                </div>
              </div>
              <div className="tbl-row">
                <div className="tbl-cell">
                  <i className="far fa-envelope-open" />
                </div>
                <div className="tbl-cell">
                  <p className="paragraph-medium paragraph-white">
                    support@pepdev.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 footer-block">
          <div className="footer-ttl">
            <p>Quick Links</p>
          </div>
          <div className="footer-container footer-b">
            <div className="tbl">
              <div className="tbl-row">
                <ul className="tbl-cell">
                  <li>
                    <a href="indexa603.html?route=contact">Contact Us </a>
                  </li>{" "}
                  <li>
                    <a href="index1b06.html?route=about">About Us </a>
                  </li>{" "}
                  <li>
                    <a href="indexacb7.html?route=doctors">Doctor </a>
                  </li>{" "}
                  <li>
                    <a href="index2378.html?route=home">Home </a>
                  </li>{" "}
                  <li>
                    <a href="indexacb7.html?route=doctors">Doctor </a>
                  </li>{" "}
                  <li>
                    <a href="index115b.html?route=services">Services </a>
                  </li>{" "}
                </ul>
                <ul className="tbl-cell">
                  <li>
                    <a href="index51d2.html?route=login">Login</a>
                  </li>
                  <li>
                    <a href="index021c.html?route=register">Register</a>
                  </li>
                  <li>
                    <a href="index2e9e.html?route=forgot">Forgot Password</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 footer-block">
          <div className="footer-ttl">
            <p>Newsletter</p>
          </div>
          <div className="footer-container footer-c">
            <div className="footer-subscribe">
              <form>
                <div className="input-box pb-0">
                  <input
                    type="text"
                    name="email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                    id="subscribe-email"
                  />
                  <label htmlFor="subscribe-email">Email Address</label>
                </div>
                <div className="footer-subscribe-button">
                  <button className="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
            <div className="social-list social-list-colored footer-social">
              <li>
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  className="fab fa-facebook"
                />
              </li>
              <li>
                <a
                  href="https://www.twitter.com/"
                  target="_blank"
                  className="fab fa-twitter"
                />
              </li>
              <li>
                <a
                  href="https://www.google.com/"
                  target="_blank"
                  className="fab fa-google"
                />
              </li>
              <li>
                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  className="fab fa-instagram"
                />
              </li>
              <li>
                <a
                  href="https://www.youtube.com/"
                  target="_blank"
                  className="fab fa-youtube"
                />
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/"
                  target="_blank"
                  className="fab fa-linkedin"
                />
              </li>
              <li>
                <a
                  href="https://www.flickr.com/"
                  target="_blank"
                  className="fab fa-flickr"
                />
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Start of Copyright Section */}
    <div id="copyright">
      <div className="layer-stretch">
        <div className="paragraph-medium paragraph-white">
          2025 © srjedu, ALL RIGHTS RESERVED{" "}
        </div>
      </div>
    </div>
    {/* End of Copyright Section */}
  </footer>
  {/* End of Footer Section */}
</>

  )
}
